module.exports = __webpack_public_path__ + "static/media/DW6010-ben5.f5c49d6e.png";